import { Button } from "../../components/index.ts";

/**
 * A reload of a To do panel failed after a good read: the last rows stay, with this line over them
 * (review F5.1). Answers, sessions and people who joined keep their actions: the server checks
 * each one against the current state. Participants to confirm turn their actions off, because that
 * write has no such check (review F6.1).
 */
export function StaleNotice({ onRetry }: { onRetry: () => void }) {
  return (
    <p className="flex flex-wrap items-center gap-2 text-[13.5px] text-ink-2">
      Not up to date.
      <Button size="sm" variant="ghost" onClick={onRetry}>
        Try again
      </Button>
    </p>
  );
}
